'use client';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Log error to console for visibility
  console.error('[PAGE ERROR]', {
    message: error.message,
    digest: error.digest,
    stack: error.stack,
  });
  
  return (
    <div className="min-h-screen bg-[#f8f8f8] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-soft p-8 text-center">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          className="mx-auto mb-4 text-[#e7131a]"
        >
          <path
            d="M12 9V11M12 15H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        
        <h2 className="text-[24px] text-black mb-2" style={{ fontFamily: 'var(--font-gilda-display), serif' }}>
          Oops! Something went wrong
        </h2>
        
        <p className="font-ibm-plex-sans text-[14px] text-gray-600 mb-6">
          We encountered an unexpected error. Don&apos;t worry, we&apos;re on it!
        </p>
        
        <button
          onClick={() => reset()}
          className="bg-[#e7131a] text-white px-6 py-3 font-ibm-plex-sans-condensed text-[14px] tracking-wider uppercase rounded-lg transition-all duration-300 hover:bg-[#c10e14] hover:opacity-90"
        >
          Try Again
        </button>
        
        {process.env.NODE_ENV === 'development' && (
          <details className="mt-6 text-left">
            <summary className="cursor-pointer text-[12px] text-gray-500 font-ibm-plex-sans">
              Error Details (Dev Only)
            </summary>
            <pre className="mt-2 p-4 bg-gray-100 rounded text-[10px] overflow-auto max-h-40">
              {error.message}
              {error.stack && '\n\n' + error.stack}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
}